export default {
      id: "doctors-note-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#doctors-note",
      toString: function () {
        return this.url;
      }
    }